import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { setOpenSnackbar } from '../../../store/slices/snackbarSlice';
import useVrackApi from '../../../hooks/useVrackApi';

AddGlobalAdminDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeHandler: PropTypes.func.isRequired,
  onAdded: PropTypes.func.isRequired
};

export default function AddGlobalAdminDialog({ isOpen, closeHandler, onAdded }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { fetchData } = useVrackApi('post', '/admin/global-admins');

  const handleAdd = async () => {
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      dispatch(setOpenSnackbar({ message: 'Please enter an email address', severity: 'warning' }));
      return;
    }

    // Basic email format check before round-tripping obviously invalid input to the backend.
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(trimmedEmail)) {
      dispatch(
        setOpenSnackbar({ message: 'Please enter a valid email address', severity: 'warning' })
      );
      return;
    }

    setLoading(true);
    try {
      await fetchData({ data: { username: trimmedEmail } });
      dispatch(setOpenSnackbar({ message: 'Global admin added successfully!' }));
      setEmail('');
      closeHandler();
      onAdded();
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || error?.message || 'Failed to add global admin';
      dispatch(setOpenSnackbar({ message: errorMessage, severity: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={closeHandler} maxWidth="sm" fullWidth>
      <DialogTitle>Add Global Admin</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter the email address of the user you wish to add as a global admin.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="email"
          label="Email Address"
          type="email"
          fullWidth
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeHandler} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleAdd} variant="contained" disabled={loading}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
